// extracted by mini-css-extract-plugin
export default {"contact":"ContactInfo_contact__FrbmX","button":"ContactInfo_button__+r7-I"};